export default __webpack_public_path__ + "static/media/more-icon.4d44f6df.svg";